<template>
  <v-card :flat="flat">
    <vue-perfect-scrollbar>
      <v-card-text class="customer-payments">
        <v-container grid-list-lg fluid class="pa-0">
          <v-layout row wrap>
            <table-skeleton :columns="3" :has-headers="true" v-if="isSearching">
            </table-skeleton>
            <v-data-table
              v-else
              :headers="headers"
              hide-actions
              class="w-100 mx-auto"
              no-data-text="No se encontraron datos"
              :items="data.data">
              <template slot="headers" slot-scope="props">
                <th v-for="(header, index) in props.headers" :key="`header-${index}`" :class="{ [header.class]: true }">
                  <v-icon class="k-orange-linear-text mr-2">{{ header.icon }}</v-icon>
                  <span>
                    {{ header.text }}
                  </span>
                </th>
              </template>
              <template slot="items" slot-scope="props">
                <tr>
                  <td class="text-xs-left">
                    {{ props.item.payment_date | formatDate }}
                  </td>
                  <td class="text-xs-center">{{ props.item.reference }}</td>
                  <td class="text-xs-right">
                    {{ props.item.amount | formatNumber }}
                  </td>
                </tr>
              </template>
            </v-data-table>
            <paginator :meta="data.meta" :limit="limit" @changePage="page = $event" v-if="Object.keys(data).length">
            </paginator>
          </v-layout>
        </v-container>
      </v-card-text>
    </vue-perfect-scrollbar>
  </v-card>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moment from 'moment';
import NotificationInfo from '@/components/customer/NotificationInfo';
import channelsMixin from '@/mixins/channels';
import TableSkeleton from '@/components/global/skeletons/TableSkeleton';
import Paginator from '@/components/global/Paginator';

export default {
  mixins: [
    channelsMixin,
  ],
  components: {
    VuePerfectScrollbar,
    NotificationInfo,
    TableSkeleton,
    Paginator,
  },
  mounted() {
    this.fetchPayments();
  },
  props: {
    customer: {
      type: Object,
      default: () => {},
    },
    tab: {
      type: String,
      default: 'tab-5',
    },
    flat: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    formatNumber(value) {
      return new Intl.NumberFormat('es-VE', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(value);
    },
  },
  data() {
    return {
      limit: 10,
      page: 1,
      data: {},
      fields: 'paymentMethod.name,invoice.balance,invoice.expires_date,invoice.total,invoice.descrip,files.name,files.original_name,date,amount,reference,internal_ref,descrip,code,batch,recipient,remote_ip',
      // dates: [],
      headers: [
        {
          text: 'Fecha',
          icon: 'fa-calendar',
          class: 'text-xs-left',
          value: 'local_schedule_date',
        },
        {
          text: 'Referencia',
          icon: 'fa-clipboard-list',
          class: 'text-xs-center',
          value: 'to',
        },
        {
          text: 'Monto',
          icon: 'fa-hand-holding-usd',
          class: 'text-xs-right',
          value: 'status',
        },
      ],
      isSearching: false,
    };
  },
  methods: {
    fetchPayments() {
      this.data = {
        data: [],
        links: {},
        meta: {},
      };
      this.isSearching = true;
      this.axios.get(`customers/${this.customer.id}/payments?page=${this.page}&fields=${this.fields}`).then(({ data }) => {
        if (!Array.isArray(data.data)) {
          data.data = Object.values(data.data);
        }
        this.data = data;
        this.isSearching = false;
      }).catch(() => {
        this.isSearching = false;
      });
    },
  },
  watch: {
    page() {
      this.fetchPayments();
    },
    tab(value) {
      if (value === 'tab-5') {
        this.fetchPayments();
      }
    },
  },
};
</script>
<style scoped>
  .customer-payments {
    height: 392px;
  }
  .customer-payments >>> .table {
    table-layout: fixed;
  }
  .customer-payments >>> .table thead tr th span {
    color: #4a4a4a;
  }
  .customer-payments >>> .table thead tr:first-child {
    border-bottom: 0px solid transparent !important;
  }
  .customer-payments >>> .datatable.table td {
    padding-top: 6px !important;
    padding-bottom: 6px !important; 
  }
  .customer-payments >>> table.table tbody tr:first-child {
    border-top: 1px solid rgba(0,0,0,.12) !important;
  }
  .customer-payments >>> table.table tbody tr {
    border-bottom: 1px solid rgba(0,0,0,.12) !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/customer/CustomerPayments.vue